import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs: FAQItem[] = [{
    question: '¿Cuándo recibo mi eBook y los bonos?',
    answer: 'Inmediatamente después de tu compra. Recibes un email con los links de descarga del eBook principal "30 Noches para Dormir en Paz" y los 2 bonos GRATIS. Puedes empezar a leer en segundos.'
  }, {
    question: '¿En qué formato vienen los eBooks?',
    answer: 'Todos los eBooks vienen en formato PDF optimizado para cualquier dispositivo. Puedes leerlos en tu teléfono, tablet, computadora, Kindle o cualquier lector de PDF.'
  }, {
    question: '¿Los bonos son realmente gratis?',
    answer: 'Sí! Los 2 bonos (Glow Up Bichota y Sobrevive a la Quincena) están incluidos completamente GRATIS con tu compra de "30 Noches para Dormir en Paz". No hay cargos adicionales ni sorpresas.'
  }, {
    question: '¿Qué pasa si no me funciona?',
    answer: 'Tienes 7 días de garantía completa. Si no estás satisfecha con el eBook o los bonos, te devolvemos tu dinero sin preguntas. Pero estamos seguras de que vas a amar tu transformación.'
  }, {
    question: '¿Puedo regalar este bundle?',
    answer: '¡Por supuesto! Es el regalo perfecto para tu mamá, hermana, amiga o cualquier mujer latina que necesite este cambio. Puedes reenviar los archivos o comprar con su email.'
  }, {
    question: '¿Por qué el precio es tan bajo?',
    answer: 'Es una oferta especial de lanzamiento. El valor real del eBook principal + los 2 bonos es de $45, pero hoy lo ofrecemos por solo $14.97 para que más mujeres latinas puedan acceder a esta transformación.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-20 bg-white" data-id="element-95">
      <div className="max-w-4xl mx-auto px-6" data-id="element-96">
        <div className="text-center mb-12" data-id="element-97">
          <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-4" data-id="element-98">
            ❓ Preguntas Frecuentes
          </h2>
          <p className="text-xl text-gray-600" data-id="element-99">Todo lo que necesitas saber</p>
        </div>

        <div className="space-y-4" data-id="element-100">
          {faqs.map((faq, index) => <div key={index} className="bg-gradient-to-r from-pink-50 to-purple-50 rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-101">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-white/50 transition-colors duration-200" data-id="element-102">
                <span className="font-bold text-lg text-navy-900 pr-4" data-id="element-103">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-magenta-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-104" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-105">
                <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-106">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-107">
          <p className="text-gray-600" data-id="element-108">
            ¿Tienes más preguntas?{' '}
            <a href="#" className="text-magenta-600 font-bold hover:text-magenta-700 underline" data-id="element-109">
              Contáctanos aquí
            </a>
          </p>
        </div>
      </div>
    </section>;
}